<!-- https://svelte.dev/examples#modal -->
<script>
	import { createEventDispatcher, onDestroy } from 'svelte';
	import { util } from '../utils/excerptsUtil.js';
	import TagsInput from '../utils/TagsInput.svelte';

	//Event actions
	const dispatch = createEventDispatcher();
	const close = () => {
		dispatch('close');
	};
	const saved = () => dispatch('saved');
	const save = () => {
		addNewExcerpt();
	};

	let modal;

	const handleKeydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}

	let newExcerptData = {
		error: '',
		success: '',
		excerpt: '',
		tags: [],
		source: '',
		description: ''
	}

	async function addNewExcerpt() {
		let isValidExcerptData = isValidExcerpt(newExcerptData);
		if (!isValidExcerptData.isValid) {
			newExcerptData.error = isValidExcerptData.errorMsg;
			return;
		} else {
			newExcerptData.error = '';
		}

        if (newExcerptData.tags == null || newExcerptData.tags.length == 0) {
			newExcerptData.error = 'Enter a tag';
			return;
		}
        
        util.addExcerpt({
			'excerpt' : newExcerptData.excerpt, 
			'source': newExcerptData.source,
			'description': newExcerptData.description,
			'tags' : newExcerptData.tags
		});

        newExcerptData.success = 'Excerpt added!';
        setTimeout(() => {
            newExcerptData.excerpt = '';
            newExcerptData.description = '';
            newExcerptData.source = '';
            newExcerptData.success = '';
            newExcerptData.tags = [];
			close();
			saved();
        }, 3000);
    }

	let maxExcerptChars = 1500;
	function isValidExcerpt(excerptData) {
		let isValid = true;
		let errorMsg = '';
		if (!excerptData.excerpt) {
			isValid = false;
			errorMsg = 'Enter some text'
		} else if (excerptData.excerpt.length > maxExcerptChars) {
			isValid = false;
			errorMsg = `Excerpt contains ${excerptData.excerpt.length} characters, allowed is ${maxExcerptChars} characters.`;  
		} else if (excerptData.tags == null || excerptData.tags.length == 0) {
			errorMsg = 'Enter a tag';
			isValid = false;
		}
		return {isValid, errorMsg};
	}

	export let inputText = null;
	export let inputSource = null;
	if (inputText != null && inputText != '') {
		newExcerptData.excerpt = inputText;
		if (inputSource != null && inputSource != '') {
			newExcerptData.source = inputSource;
		}
	
		//Change focus to next field
		window.onload = function() {
			let tagsField = document.getElementById('new-excerpt-source');
			tagsField.focus();
		}
		
	}

	//Make excerpt content textarea dynamically resizable
	window.onload = function() {
	let textArea = document.getElementById("new-excerpt");
		textArea.setAttribute("style", "height:" + Math.max(70, textArea.scrollHeight) + "px;");
		textArea.addEventListener("input", setHeight, false);
	}

	function setHeight() {
		this.style.height = 0;
		this.style.height = Math.max(70, this.scrollHeight) + "px";
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

<div role="dialog" aria-modal="true" bind:this={modal}>
	<h1>
		Add new excerpt
	</h1>

	<hr>
	<label id="new-excerpt__label" for="new-excerpt">Enter the excerpt*:</label>
	<!-- svelte-ignore a11y-autofocus -->
	<textarea autocomplete="off" bind:value={newExcerptData.excerpt} autofocus type="text" id="new-excerpt" name="new-excerpt" class="inputs"/>

	<label id="new-excerpt__source-label" for="new-excerpt-source">Enter the source:</label>
	<input autocomplete="off" bind:value={newExcerptData.source} type="text" id="new-excerpt-source" name="new-excerpt-source" class="inputs"/>

	<label id="new-excerpt__description-label" for="new-excerpt-description">Enter the description:</label>
	<input autocomplete="off" bind:value={newExcerptData.description} type="text" id="new-excerpt-description" name="new-excerpt-description" class="inputs"/>

	<label id="new-tag__label" for="new-tags">Enter tags*:</label>
	<TagsInput bind:selectedTags={newExcerptData.tags}/>

	<div id="new-excerpt__error">
		{newExcerptData.error} 
	</div>
	<div id="new-excerpt__success">
		{newExcerptData.success} 
	</div>
	<hr>

    <div class="buttons">
        <button class="btn-secondary" on:click={close}>Cancel</button>
        <button class="btn-primary" on:click={save}>Save</button>
    </div>
</div>

<style>
    .buttons {
        display: flex;
        gap: 1em;
		margin-top: 1em;
    }

	button {
		display: block;
		width: 100%;
		border: none;
		padding: 0.8em 1.2em;
		border-radius: 8px;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.2s ease-in-out;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.btn-primary {
		background: linear-gradient(to right, var(--primary-color), var(--primary-color-dark));
		color: var(--text-color-light);
	}

	.btn-primary:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}

	.btn-secondary {
		background: var(--secondary-color);
		color: var(--text-color-light);
	}

	.btn-secondary:hover {
		background: var(--secondary-color-dark);
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}
	
	button:disabled,
	button[disabled]{
		background: var(--disabled-color);
		color: var(--disabled-text-color);
		cursor: not-allowed;
		box-shadow: none;
		transform: none;
	}

	label {
		font-size: 1.1em;
		margin-top: 1em;
		display: inline-block;
	}

	#new-excerpt__error {
		color: red;
		margin-top: 0.5em;
	}
	#new-excerpt__success {
		color: green;
		margin-top: 0.5em;
	}
	#new-excerpt {
		resize: none;
		overflow-y: auto;
		min-height: 3em;
    	max-height: 8em;
		width: 100%;
	}
</style>